import { ChangeDetectorRef, Component, HostListener, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState, selectAuthDataCommonState, selectLanguageInCommonState } from 'app/app-state.index';
import { LoginService } from 'app/login/services/login.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { AuthData } from 'app/shared/model/auth-data.model';
import { Language } from 'app/shared/model/enums';
import { Subscription } from 'rxjs';
import { AppAuthService } from '../../../../shared/services/app-auth.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {
  languages = []
  selectedLanguage =
    { icon: '', code: null }
  isLoggedOn
  isDomainHe: boolean = false;
  scrolled: boolean = false;
  subscriptions = new Subscription();
  constructor(private localizationService: LocalizationService, authService: AppAuthService,
    private loginService: LoginService, private router: Router, store: Store<AppState>, private cdr: ChangeDetectorRef,
    private ngZone: NgZone) {
    this.subscriptions.add(store.select(selectLanguageInCommonState).subscribe(language => {
      this.languages = [];
      this.selectedLanguage.code = language;
      this.selectedLanguage.icon = language == Language.he ? '/assets/images/hebrew.png' : '/assets/images/english.png'
      this.languages.push(this.selectedLanguage);
      this.languages.push({ code: this.selectedLanguage.code == Language.he ? Language.en : Language.he, icon: this.selectedLanguage.code == Language.he ? '/assets/images/english.png' : '/assets/images/hebrew.png' });
    }));
    this.subscriptions.add(store.select(selectAuthDataCommonState).subscribe(() => {
      this.isLoggedOn = authService.isLoggedOn;

    }))
    this.languages = [
      { icon: '/assets/images/hebrew.png', code: Language.he },
      { icon: '/assets/images/english.png', code: Language.en },
    ];
  }
  ngOnInit(): void {
    this.checkDomain()
  }
  checkDomain() {
    const hostname = window.location.hostname;
    if (hostname === 'spintuwin.com') {
      this.isDomainHe = true
    }
    else if (hostname === 'spintowindiners.com') {
      this.isDomainHe = false
    }
  }
  changeLanguage() {
    this.localizationService.changeLanguage(this.selectedLanguage.code)
  }
  login() {
    this.ngZone.run(() => this.router.navigate(['/'], { queryParams: { returnUrl: 'webplatform/my-roulettes' } }));
    this.loginService.showLoginDialog()
  }
  createRoulette() {
    this.router.navigate([`roulette`])
  }
  @HostListener("window:scroll", [])
  onWindowScroll() {
    this.scrolled = window.scrollY > 640;
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  scrollTo(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
